module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-capacity.4cb6b4c6.png";